import { render } from "./App.vue?vue&type=template&id=7873cb28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7873cb28&lang=sass"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll,QDate});
